export default {
    menu: {
        home: 'Home',
        news: 'News',
        product: 'Products',
        solution: 'Solutions',
        cases: 'Cases',
        about: 'About Us',
        service: 'Service',
        download: 'Download'
    },
    home: {
        latestNews: 'Latest News',
        successfulCases: 'Successful Cases',
        details: 'Details'
    },
    news: {
        title: 'News Center',
        companyNews: 'Company News',
        industryNews: 'Industry News',
        details: 'Details'
    },
    product: {
        title: 'Product Center',
        recorder: 'Body Camera',
        workstation: 'Data Station',
        system: 'Body Camera System',
        cabinet: 'Smart Cabinet',
        intercom: 'Intercom',
        details: 'Details'
    },
    solution: {
        title: 'Solutions',
        lawEnforcement: 'Law Enforcement Solutions',
        smartCabinet: 'Smart Cabinet Solutions',
        details: 'Details'
    },
    download: {
        title: 'Download Center',
        name: 'Name',
        download: 'Download',
        clickToDownload: 'Click to Download'
    },
    service: {
        title: 'User Service',
        afterSalesService: 'After-sales Service',
        serviceSystem: 'Service Support System',
        serviceDesc1: 'Guangdong Tongchuanglian New Technology Co., Ltd., with years of industry service experience and the service purpose of "providing users with the best service", provides customers with the most complete and overall system services including pre-sales, in-sales, after-sales and technical support with "integrity, convenience, enthusiasm and professionalism".',
        serviceDesc2: 'Tongchuanglian New Technology service system consists of two major parts: headquarters service agencies and regional service agencies.',
        serviceNetwork: 'Service Network: Tongchuanglian has more than 10,000 service outlets and more than 20,000 after-sales engineers nationwide',
        quickResponse: 'Quick Response: "7x24 hours" all-weather manual answering service, 24-hour door-to-door service in central cities',
        hotline: '24-hour Hotline: 4009-123456',
        afterSalesPolicy: 'After-sales Policy',
        policeServicePolicy: 'Police Product Service Policy',
        serviceCommitment: 'I. Service Commitment',
        nationalWarranty: 'National Warranty, Lifetime Maintenance',
        warrantyPolicy: 'II. Warranty Policy',
        warrantyDesc: 'According to the product characteristics of Tongchuanglian police product service policy (special industry use) and referring to the national "Provisions on the Responsibility for Repair, Replacement and Return of Some Products", the following service responsibilities are committed.',
        exchangePolicy: 'III. Exchange and Return Policy',
        exchangeRule1: '1. Once the product is sold and identified by customer service personnel as a product quality failure, you can apply for replacement within 15 days from the date of purchase.',
        exchangeRule2: '2. If the configuration does not meet customer requirements due to Tongchuanglian staff, you can apply for replacement within 7 days from the date of purchase;',
        exchangeRule3: '3. For exchanges and returns, customers must ensure the integrity of product appearance, wires and packaging. Otherwise, Tongchuanglian has the right to charge the cost of raw materials according to the situation.',
        nonWarrantyScope: 'IV. Non-warranty Scope During Warranty Period',
        nonWarrantyDesc: 'During the warranty period, the following situations are not covered by free warranty, nor do they provide exchange or return, and paid repair services will be implemented:',
        nonWarrantyItem1: '1. Failures or damages caused by incorrect installation, operation or use in working environments not specified for the product;',
        nonWarrantyItem2: '2. Failures or damages caused by unauthorized disassembly, repair or modification of the product without Tongchuanglian authorization;',
        nonWarrantyItem3: '3. Failures or damages caused by natural disasters or other force majeure factors after purchase;',
        nonWarrantyItem4: '4. Product labels are destroyed or dates are altered;',
        nonWarrantyItem5: '5. Software virus infections caused by improper customer maintenance;',
        nonWarrantyItem6: '6. Physical damage to customer repair machines received by our company due to packaging or freight company reasons.',
        nonWarrantyItem7: '7. No three-guarantee certificate or valid invoice, or the model on the three-guarantee certificate does not match the repaired product model or has been altered.',
        nonWarrantyItem8: '8. Abnormal changes or loss of device storage data, etc.',
        warrantyPeriod: 'V. Definition of Warranty Period',
        warrantyPeriodRule1: '1. Customers can enjoy warranty service by providing valid warranty certificates (order contract, purchase invoice), and the warranty period is calculated from the transaction date of the certificate; if the date on the warranty certificate provided by the customer differs from the product factory date by more than 6 months, the warranty start date is calculated as 3 months after the product factory date (shipment date from Tongchuanglian warehouse);',
        warrantyPeriodRule2: '2. When customers cannot provide valid warranty certificates, the warranty start date is calculated as 3 months after the factory date of the product barcode;',
        outOfWarrantyFee: 'VI. Charges Outside Warranty Scope',
        outOfWarrantyDesc: 'After the free warranty period expires or outside the warranty scope, repair services are executed according to the following principles:',
        feeRule1: '1. Product repairs outside the warranty scope require inspection fees and component fees (cost price standard).',
        feeRule2: '2. For products beyond the warranty period that are confirmed by our technical department to be too severely damaged or unable to be repaired for other reasons, our company will return the original item. If you need to replace with other models of similar products, you can replace the product according to the depreciation compensation principle.',
        others: 'VII. Others',
        othersDesc: 'This service policy applies to Tongchuanglian agents, direct sales customers, etc. If the service commitment exceeds this policy, the content of the contract signed by both parties shall prevail, and the principle of whoever promises shall fulfill shall be followed.'
    },
    about: {
        title: 'About Us',
        companyIntro: 'Company Profile',
        companyHonor: 'Company Honors',
        serviceUsers: 'Our Clients',
        development: 'Development History',
        honorTitle: 'Company Honors',
        clickToView: 'Note: Click image to view larger',
        patentInvention: 'Invention Patents',
        qualityAAA: 'Quality Integrity AAA Enterprise',
        patentNew: 'Utility Model Patents',
        innovationOutstanding: 'Outstanding Enterprise in Police Equipment Technology Innovation for Four Consecutive Years',
        patentAppearance: 'Design Patents',
        innovationAward: 'Grand Award in Police Equipment Technology Innovation for Four Consecutive Years',
        highTechEnterprise: 'Provincial High-tech Enterprise',
        topTenBrand: 'Top Ten Brands in Police Equipment for Three Consecutive Years',
        contractCredit: 'Provincial Contract-abiding and Credit-worthy Enterprise',
        committeeUnit: 'Member Unit of Ministry of Public Security Social Public Safety Application Basic Standardization Technical Committee',
        draftUnit2011: 'Main Drafting Unit of GA/T 947-2011 "Single Police Law Enforcement Audio and Video Recorder"',
        draftUnit2015: 'Main Drafting Unit of GA/T 947.1-2015 "Single Police Law Enforcement Audio and Video Recording System"',
        fiveStarService: 'Five-star After-sales Service Certification Enterprise, Main Drafting Unit of GB/T 33170 "Safety Requirements for Large-scale Activities"'
    },
    footer: {
        news: 'News Center',
        companyNews: 'Company News',
        industryNews: 'Industry News',
        products: 'Products',
        recorder: 'Body Camera',
        workstation: 'Data Station',
        system: 'Body Camera System',
        cabinet: 'Smart Cabinet',
        solutions: 'Solutions',
        industrySolution: 'Law Enforcement Solutions',
        cabinetSolution: 'Smart Cabinet Solutions',
        about: 'About Us',
        history: 'History',
        culture: 'Culture',
        honors: 'Honors',
        partners: 'Partners',
        service: 'Service',
        afterSales: 'After-sales Service',
        policy: 'Service Policy',
        contact: 'Contact Us',
        email: 'Email: tcl@tcl-cctv.com',
        phone: 'Phone: 4009-123456',
        address: 'Address: G3-307, TCL International E City, Nanshan District, Shenzhen, Guangdong',
        copyright: 'Copyright © Guangdong Tongchuanglian New Technology Co., Ltd. All Rights Reserved. ICP: 09043526'
    }
}
